<div
  class="access-actions fixed bottom-0 inset-x-0 z-10 flex flex-col gap-4 px-6 py-4 bg-neutral-50 border-t-neutral-200 lg:static lg:p-0 lg:border-0 lg:bg-transparent"
  data-testid="access-actions"
>
  <ng-content></ng-content>
</div>
